module.exports = __webpack_public_path__ + "img/banner-edu.f4749c81.png";